import { useState, useEffect } from "react";
import axios from "axios";
import appConfig from "config/appConfig";
import { verifyTokenExpire } from "middleware/verifyToken";

export const useCoefficientData = () => {
  const [data, setData] = useState({
    coef: "",
    domaine_prefixe: [],
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    if (!verifyTokenExpire()) return;

    try {
      setIsLoading(true);
      const response = await axios.get(
        `${appConfig.apiDomaine}/configurations/relance`
      );

      setData({
        coef: response.data.coef || "",
        domaine_prefixe: response.data.domaine_prefixe || [],
      });
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { data, isLoading, error, refetch: fetchData };
};
